// extracted by mini-css-extract-plugin
export default {"copy-bubble":"copyTextToClipboardButton_copy-bubble__ukEJn"};